import '../App.scss';
import { NavLink } from 'react-router-dom';

const TopsideMenu = () => {
  return (
    <div className="topsideMenu">
      <NavLink to="/" className="linkNodecore">
        <span>#xkupriyanov.ru</span>
      </NavLink>
    </div>  
  );
}

export default TopsideMenu;